<script setup lang="ts">
defineProps<{
  message?: string
  title?: string
}>()
</script>

<template>
  <div
    class="bg-default font-poppins flex h-screen flex-col p-10 text-[16px] sm:h-[540px] sm:rounded-xl sm:shadow-xl"
  >
    <header :class="{ 'pb-5': message }">
      <RialticLogo class="h-10" />
      <h1
        class="mt-6 mb-4 text-[24px] leading-9 font-semibold tracking-normal text-default"
      >
        {{ title || 'Welcome' }}
      </h1>
      <p v-if="message" class="text-sm leading-[21px] text-muted">
        {{ message }}
      </p>
    </header>
    <slot />
  </div>
</template>
